(ns frontend.view.components.sidenavs.named-views.view
  (:require
   [common.util :as cu :refer [remove-empty-vals]]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]
   [ui.components.button.view :as button]))

(defn named-view
  [{:keys [named-view selected? load-view!]}]
  (let [{:keys [named-view/name :db/id]} named-view]
    [:div
     {:class-name (fu/cs "named-view-container"
                         (when selected? "selected"))
      :on-click   load-view!}
     name]))

(defn view
  [{:keys [named-views current-view minimized? toggle-minimize!
           load-view! class-name]
    :as   view-args}]
  [:div
   {:style      {:height "100%"}
    :class-name (fu/cs "named-views-sidenav named-views-sidenav--left-gap"
                       (when minimized? "minimized")
                       class-name)}
   [:div
    {:class-name "px-3"}

    [:div 
     {:class "absolute right-0 top-3"}
     [button/square-secondary-open
      {:on-click toggle-minimize!}
      (if minimized?
        [:i.fal.fa-angle-double-right]
        [:i.fal.fa-angle-double-left])]]
    [:div.named-views-content
     (for [named named-views
           :let [{:keys [db/id named-view/settings]} named]]
       ^{:key id}
       [named-view
        {:named-view named
         :selected?  (= (remove-empty-vals settings)
                        (remove-empty-vals current-view))
         :load-view! (partial load-view! named)}])]]])
